import { FileService } from '../../services/file.service';
import { NgProgress } from 'ngx-progressbar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  OnDestroy
} from '@angular/core';
import { IMenu } from '../../models/imenu.model';
import { ManageService } from '../../services/manage.service';
import { NgProgressService } from '../../services/ngProgress.service';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-manage-upcoming-opportunity',
  templateUrl: './manage-upcoming-opportunity.component.html',
  styleUrls: ['./manage-upcoming-opportunity.component.css']
})
export class ManageUpcomingOpportunityComponent implements OnInit, OnDestroy {
  partnerCSN: string;
  partnerName: string;

  title = 'AutoDesk';
  loadContent = false;

  searchField;

  narrowMode = true;
  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;

  constructor(
    private activeRouter: ActivatedRoute,
    public ngProgress: NgProgressService,
    private router: Router,
    private manageService: ManageService,
  ) {
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }
  
  ngOnInit() {
    this.manageService.currentValueWatch.subscribe(data => setTimeout(() => this.partnerCSN = data));
    this.manageService.currentVendorWatch.subscribe(data => setTimeout(() => this.partnerName = data));
    this.router.events.pipe(filter(value => value instanceof NavigationEnd))
      .subscribe((value: any) => {
        this.activeRouter.paramMap.subscribe(param => {
          this.loadContent = false;
        });
        let currentUrl = this.router.url;
        if (currentUrl.includes('search')) {
          $('#searchValue').addClass('active');
        } else {
          $('#searchValue').removeClass('active');
        }
      });

  }

  isActive(opportunityID: string): boolean {
    if (this.router.url.includes('search')) {
      return false;
    } else {
      return true;
    }
    // return this.router.url.includes(opportunityID);
  }

  search(field: string) {
    if (field.length === 0) {
      return;
    }
    const searchValue = field.trim();
    this.manageService.monitorSearchKeyWordChange(searchValue);
    this.router.navigate([`/manageRenewalsNew/renewalsEndUser/upComing/${this.partnerName}/${this.partnerCSN}/search/${searchValue}`], {
      relativeTo: this.activeRouter,
    });
  }

  close() {
    this.router.navigateByUrl('/manageRenewalsNew');
  }

  ngOnDestroy() {

  }
}
